import { render } from "./Button-icon-text.vue?vue&type=template&id=5f32a1a5&scoped=true"
import script from "./Button-icon-text.vue?vue&type=script&lang=js"
export * from "./Button-icon-text.vue?vue&type=script&lang=js"

import "./Button-icon-text.vue?vue&type=style&index=0&id=5f32a1a5&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f32a1a5"]])

export default __exports__